import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: '100%',
    margin: 0,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    boxShadow: '0px 3px 6px #0000001A',
    textAlign: 'center',
    padding: 25,
  },
  searchIcon: {
    '& svg': {
      color: '#777',
      width: 16,
    },
  },
  searchBox: {
    maxWidth: 280,
  },
  fleetDisclaimer: {
    color: theme.palette.warning.main,
    textAlign: 'justify',
    display: 'block',
    marginBottom: '1rem',
  },
}));

export default useStyles;
